// extracted by mini-css-extract-plugin
export default {"root":"Waiting_root__ms1px","title":"Waiting_title__FD7h9"};